import React from 'react';
import { ScrollView, useWindowDimensions, View } from "react-native";
import Card from 'theme/Card'
import Modal from 'theme/Modal';
import { topNavigationProps } from "styles/top-navigation";
import Title from 'components/atoms/Title'
import Description from 'components/atoms/Description'
import { ThemedModalStyles } from 'styles/components/atoms/ThemedModal'
import ThemedPressable from 'components/atoms/ThemedPressable'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import _ from 'lodash'

const ThemedModal = ({ visible = false, setVisible, footer, title, subtitle, children }) => {
	
	const dimensions = useWindowDimensions()
	
	const modalStyle = [
		ThemedModalStyles.modal,
		{
			maxHeight: ( dimensions.height / 100 ) * 90
		}
	]
	
	// Set card props
	let cardProps = {};
	if( footer ) {
		cardProps['footer'] = props => {
			return (
				<View {...props}>
					<View
						style={ ThemedModalStyles.cardFooter }>

						{ footer }
					</View>
				</View>
			);
		};
	}
	
	return (
		<Modal
			visible={ visible }
			backdropStyle={ ThemedModalStyles.backdrop }
			style={ modalStyle }>
			
			<Card
				header={ props => {
					return (
						<View
							{...props}>

							<View style={ ThemedModalStyles.cardHeader }>
								<View style={ ThemedModalStyles.cardHeaderLeft }>
									{ title && (
										<Title
											style={ {
												marginBottom: subtitle ? 10 : 0
											} }>

											{ title }
										</Title>
									)}

									{ subtitle && (
										<Description>
											{ subtitle }
										</Description>
									)}
								</View>

								{ _.isFunction( setVisible ) && (
									<View
										style={ ThemedModalStyles.cardHeaderRight }>

										<ThemedPressable
											onPress={ setVisible.bind( this, false ) }>

											<Icon icon={ IconSystemConstants.CLOSE } { ...topNavigationProps.icon } />
										</ThemedPressable>
									</View>
								)}
							</View>
						</View>
					);
				}}
				{ ...cardProps }
				style={ ThemedModalStyles.card }>
				
				<ScrollView
					style={ ThemedModalStyles.scrollView }>
					
					{ children }
				</ScrollView>
			</Card>
		</Modal>
	)
}

export default ThemedModal
